<div class="modal-header d-flex  justify-content-between">
    <h5 class="modal-title" i18n>Add package {{isReturn?'RETURN':''}}</h5>
    <button (click)="close()" type="button" class="btn btn-sm btn-danger" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form>
        <div class="d-flex flex-column gap-2 mb-3">

            <div class="mb-2">
                Bruger: <strong>{{userKey}}</strong>
            </div>

            <label class="form-check-label">
                Send fra afdeling
            </label>

            <select class="form-control form-select"
                    name="shipment-route-id"
                    [(ngModel)]="branch"
                    [disabled]="loading">
                <option [value]="null">-</option>
                <ng-template ngFor let-branch [ngForOf]="branches">
                    <option [value]="branch.key">{{ branch.name }}
                    </option>
                </ng-template>
            </select>


            <label class="form-check-label">
                <input class="form-check-input" type="checkbox"
                       [(ngModel)]="getPdf"
                       [ngModelOptions]="{standalone: true}">
                &nbsp;Download PDF
            </label>
            <label class="form-check-label" *ngIf="activeShipment.checkUn()">
                <input class="form-check-input" type="checkbox"
                       [(ngModel)]="enableDg"
                       [ngModelOptions]="{standalone: true}">
                &nbsp; Farlig Gods
            </label>
        </div>

        <div class="mb-3">
            <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="this.validationErrorMessage">{{ this.validationErrorMessage }}</ngb-alert>
            <ng-container *ngIf="activeShipment.shipment_product_lines.length > 0">
                <div class="d-flex align-items-start gap-2 flex-wrap mb-3">
                    <ng-container *ngFor="let service of activeShipmentPackagings">
                        <button
                                type="button"
                                class="btn btn-sm"
                                *ngIf="service?.selectable"
                                [ngClass]="{'btn-outline-success':!service.selected, 'btn-success':service.selected}"
                                (click)="selectPackaging(service)">{{ service.packageType }}
                        </button>
                    </ng-container>
                </div>
                <ng-container *ngFor="let service of activeShipmentPackagings">
                    <app-shipment-packaging-info
                            *ngIf="service.selected"
                            [weight]="kolliData.sumWeight"
                            [price]="kolliData.price ? kolliData.price : service.price"
                            [packaging]="service"></app-shipment-packaging-info>
                </ng-container>
            </ng-container>
        </div>

        <div class="mb-3" *ngIf="isReturn">
            <select class="form-control  form-control-sm"
                    name="product_code"
                    (ngModelChange)="changeProductCode($event)"
                    [ngModel]="productCode"
                    [disabled]="saving">
                <option i18n [value]="null">No Product</option>
                <ng-template ngFor let-carrier [ngForOf]="returnProducts">
                    <option [ngValue]="carrier">{{ carrier.name }}
                    </option>
                </ng-template>
            </select>

            <span class="text-danger" *ngIf="isReturn && !selectedReturnProduct">Vælg en retur metode</span>
        </div>

        <div class="mb-3" *ngIf="isReturn && selectedReturnProduct?.showDatepicker">
            <app-date-time-picker [(date)]="pickupDate"
                                  [options]="{calendarWeeks:true, format: 'DD-MM-YYYY'}"
                                  [inputSmall]="true"
                                  id="shipment-shipping-date"
                                  type="text"
                                  name="shipment-shipping-date"></app-date-time-picker>
            <span class="text-danger" *ngIf="isReturn && !pickupDate">Vælg en dato</span>
        </div>

        <table class="table  table-sm  table-striped" *ngIf="activeShipment.shipment_product_lines && activeShipment.shipment_product_lines.length > 0">
            <thead>
                <tr>
                    <th i18n>Produkt</th>
                    <th i18n>DB Nr. / EAN</th>
                    <th i18n>Dim</th>
                    <th i18n>Antal</th>
                    <th class="text-end" i18n>Pakket</th>
                    <th class="text-end" i18n>Total</th>
                </tr>
            </thead>

            <tbody>
                <ng-container *ngFor="let product_line of activeShipment.shipment_product_lines; let i = index;">
                    <tr *ngIf="product_line.amount > 0">
                        <td>
                            <span>
                                {{ product_line.product_text_1 }}<br>
                                {{ product_line.product_text_2 }}<br>
                                {{ product_line.product_text_3 }}
                            </span>

                            <app-dg-badges [productLine]="product_line"></app-dg-badges>
                        </td>
                        <td>{{ product_line.product_number }}<br><code>{{product_line.product_number_ean}}</code></td>
                        <td>
                            <div class="d-flex gap-1 flex-column">
                                <span>{{ product_line?.weight ? product_line.weight : '-' }} kg</span>
                                <span>(LxBxH) {{ product_line.length }} x {{ product_line.width }} x {{ product_line.height }} m</span>
                                <span class="badge text-bg-danger rounded-pill"                                      *ngIf="!product_line.weight">INGEN VÆGT</span>
                            </div>
                        </td>
                        <td>
                            <input type="number"
                                   [disabled]="product_line.weight <= 0"
                                   (ngModelChange)="updateShippedAmount($event,product_line)"
                                   [ngModel]="product_line.amount_scanned" min="0" max="{{ product_line.amount }}" class="form-control" name="products-{{i}}-amount">
                        </td>
                        <td class="text-end"><span>{{ product_line.amount_picked }}</span></td>
                        <td class="text-end"><span> / {{ product_line.amount }}</span></td>
                    </tr>
                </ng-container>
            </tbody>
        </table>

        <h3>Labels</h3>
        <table class="table  table-sm  table-striped">
            <thead>
            <tr>
                <tr>
                    <th>Beskrivelse</th>
                    <th i18n> Vægt</th>
                    <th *ngIf="selectablePackagings.length > 0" >Emballage</th>
                    <th i18n> Price</th>
                    <th i18n> </th>
                </tr>
            </thead>
            <tbody>
            <tr *ngFor="let customProduct of customProducts; let index = index">
                <td><input
                        class="form-control"
                        [(ngModel)]="customProduct.product_text_1" [name]="'name'+index"></td>
                <td>
                    <app-number-input [value]="customProduct.weight"
                                      (valueChange)="changeCustomProduct($event, customProduct)"></app-number-input>

                    <span class="badge text-bg-danger rounded-pill mt-1"
                          *ngIf="customProduct.error">{{ customProduct.error }}</span>
                </td>
                <td *ngIf="selectablePackagings.length > 0">
                    <select
                            [name]="'packaging-'+index"
                            class="form-control form-select" [(ngModel)]="customProduct.packaging"
                            (change)="handleAdHocValidation()"
                    >
                        <ng-container *ngFor="let service of activeShipmentPackagings">
                            <option [ngValue]="service" *ngIf="service.selectable">{{ service.packageType }}</option>
                        </ng-container>
                    </select>
                </td>
                <td>
                    <app-shipment-packaging-info [packaging]="customProduct.packaging" [price]="customProduct?.price ? customProduct?.price  : customProduct?.packaging?.price"></app-shipment-packaging-info>
                </td>
                <td>
                    <button (click)="removeCustomProduct(customProduct)" class="btn btn-danger">Fjern</button>
                </td>
            </tr>
            </tbody>
        </table>

        <button (click)="addCustomProduct()" class="btn btn-sm btn-primary mb-3">Tilføj</button>
    </form>


<ng-container *ngIf="hasStykgods">
    <h3>Dimensioner <span class="badge-warning badge">Stykgods</span></h3>

    <div class="d-flex gap-3">
        <div class="flex-grow-1">

            <label class="form-label">Højde (cm)</label>
            <app-number-input [(value)]="dimensions.height"></app-number-input></div>
        <div class="flex-grow-1"

        ><label class="form-label">Længde (cm)</label><app-number-input [(value)]="dimensions.length"></app-number-input></div>
        <div class="flex-grow-1"><label class="form-label">Bredde (cm)</label><app-number-input [(value)]="dimensions.width"></app-number-input></div>

    </div>

</ng-container>

    <small>Priser er inkl. moms, inkl. 6% DG</small>
</div>

<div class="modal-footer">
    <button (click)="close()" type="button" class="btn btn-secondary" [disabled]="saving">
        <span i18n>Close</span>
    </button>

    <button (click)="getPrices()" type="button" class="btn btn-secondary" [disabled]="hasValidationErrors || saving || (isReturn && !selectedReturnProduct)">
        {{ saving ? 'Getting...' : 'Udregn priser' }}
    </button>

    <button (click)="save()" type="button" class="btn btn-primary" [disabled]="hasValidationErrors || saving || (isReturn && !selectedReturnProduct)">
        {{ saving ? 'Printing...' : 'Print' }}
    </button>
</div>
